module.exports = __webpack_public_path__ + "static/media/background.11560f11.jpg";